// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._154i1ssb{top:50%}
._154iidpf{top:0}
._1ltv1ssb{left:50%}
._1ltvidpf{left:0}
._1pby1qpw{z-index:520}
._1xi2idpf{right:0}
._94n5idpf{bottom:0}
._kqsw1n9t{position:fixed}
._kqswstnw{position:absolute}
._t9ec1ooe{transform:translate(-50%,-50%)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-ui/dist/esm/modalSpinner-compiled.compiled.css"],"names":[],"mappings":"AAAA,WAAW,OAAO;AAClB,WAAW,KAAK;AAChB,WAAW,QAAQ;AACnB,WAAW,MAAM;AACjB,WAAW,WAAW;AACtB,WAAW,OAAO;AAClB,WAAW,QAAQ;AACnB,WAAW,cAAc;AACzB,WAAW,iBAAiB;AAC5B,WAAW,8BAA8B","sourcesContent":["._154i1ssb{top:50%}\n._154iidpf{top:0}\n._1ltv1ssb{left:50%}\n._1ltvidpf{left:0}\n._1pby1qpw{z-index:520}\n._1xi2idpf{right:0}\n._94n5idpf{bottom:0}\n._kqsw1n9t{position:fixed}\n._kqswstnw{position:absolute}\n._t9ec1ooe{transform:translate(-50%,-50%)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
